// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"99":"1a1014c4","138":"8fe347d1","273":"650cc46b","344":"2a28a48c","437":"c25dfcfb","923":"90c4b828"}[chunkId] + ".chunk.js";
};